export const SLIDER_OPTIONS_MINI = {
    animation: {
        type: 'monoSlider'
    },
    controls: {
        arrows: { enabled: true },
        bullets: { enabled: false },
        buttons: { enabled: false }
    }
};

export const GAMES_PER_SLIDE_MIN = 2;
